import React from 'react';

// Shared button primitive. Encapsulates the repeated inline button styles
// across the app and pins them to brand tokens. Pass `variant` for intent and
// `style` to override/extend. All other props (onClick, disabled, type...) pass through.
const base = {
  border: 'none',
  borderRadius: 8,
  padding: '10px 16px',
  fontWeight: 600,
  fontSize: 14,
  lineHeight: 1.2,
  cursor: 'pointer',
  fontFamily: 'inherit',
};

const VARIANTS = {
  primary: { background: 'var(--primary-color)', color: 'var(--white)' },
  accent: { background: 'var(--accent-color)', color: 'var(--white)' },
  success: { background: 'var(--success-color)', color: 'var(--white)' },
  danger: { background: 'var(--error-color)', color: 'var(--white)' },
  ghost: { background: 'transparent', color: 'var(--primary-color)', border: '1px solid var(--border-color)' },
  subtle: { background: 'var(--surface-muted)', color: 'var(--text-strong)', border: '1px solid var(--border-color)' },
};

export default function Button({ variant = 'primary', style, disabled, ...rest }) {
  return (
    <button
      disabled={disabled}
      style={{
        ...base,
        ...(VARIANTS[variant] || VARIANTS.primary),
        ...(disabled ? { opacity: 0.6, cursor: 'not-allowed' } : {}),
        ...style,
      }}
      {...rest}
    />
  );
}
